"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function ($) {
  // Settings
  var endpoints = {
    list_cookbooks: '/ajax/api/cookbook/list',
    create_cookbook: '/ajax/api/cookbook/create',
    list_cookbooks_has_recipe: '/ajax/api/cookbook/list/has-recipe/{recipe_id}',
    add_recipe: '/ajax/api/cookbook/{cookbook_id}/add-recipe/{recipe_id}',
    remove_recipe: '/ajax/api/cookbook/{cookbook_id}/remove-recipe/{recipe_id}'
  }; //////////

  var CookbookData = /*#__PURE__*/function () {
    function CookbookData() {
      _classCallCheck(this, CookbookData);

      this._cookbooks = null;
    }
    /**
     * Get user's cookbooks, including the recipe ids in each
     *
     * @public
     * @async
     * @return {jQuery Deferred}
     */


    _createClass(CookbookData, [{
      key: "getCookbooks",
      value: function getCookbooks() {
        var _this = this;

        var defer = $.Deferred();

        if (this._cookbooks === false) {
          defer.reject(false); // anonymous user
        } else if (this._cookbooks != null) {
          defer.resolve(this._cookbooks);
        } else {
          var url = replaceTokens(endpoints.list_cookbooks);
          $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            dataType: 'json'
          }).done(function (response, textStatus, jqXHR) {
            if (response.data.can_have_cookbooks === false) {
              _this._cookbooks = false;
              defer.reject(false);
            } else {
              _this._cookbooks = response.data.cookbooks;
              defer.resolve(_this._cookbooks);
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            defer.reject();
          });
        }

        return defer;
      }
      /**
       * Create cookbook
       *
       * @public
       * @async
       * @param {String} title
       * @param {Integer} recipe_id
       * @return {jQuery Deferred}
       */

    }, {
      key: "createCookbook",
      value: function createCookbook(title, recipe_id) {
        var _this2 = this;

        var defer = $.Deferred();
        var url = replaceTokens(endpoints.create_cookbook);
        $.ajax({
          url: url,
          type: 'POST',
          data: {
            title: title,
            recipes: [recipe_id]
          },
          cache: false,
          dataType: 'json'
        }).done(function (response, textStatus, jqXHR) {
          // TODO: Handle a possible soft failure...
          var data = response.data;

          _this2._addCookbookToCookbooksData(data.cookbook.id, data.cookbook.title, data.cookbook.recipes).then(function (result) {
            return defer.resolve(data);
          });
        }).fail(function (jqXHR, textStatus, errorThrown) {
          var _jqXHR$responseJSON, _jqXHR$responseJSON$e;

          var message = jqXHR === null || jqXHR === void 0 ? void 0 : (_jqXHR$responseJSON = jqXHR.responseJSON) === null || _jqXHR$responseJSON === void 0 ? void 0 : (_jqXHR$responseJSON$e = _jqXHR$responseJSON.errors[0]) === null || _jqXHR$responseJSON$e === void 0 ? void 0 : _jqXHR$responseJSON$e.title;
          defer.reject(message);
        });
        return defer;
      }
      /**
      * Add recipe to cookbook
      *
      * @public
      * @async
      * @param {Cookbook} cookbook
      * @param {Integer} recipe_id
      * @param {String} recipe_name
      * @return {jQuery Deferred}
      */

    }, {
      key: "addRecipe",
      value: function addRecipe(cookbook, recipe_id, recipe_name) {
        var _this3 = this;

        var defer = $.Deferred();
        var cookbook_id = cookbook.id;
        var url = replaceTokens(endpoints.add_recipe, {
          recipe_id: recipe_id,
          cookbook_id: cookbook_id
        });
        $.ajax({
          url: url,
          type: 'GET',
          cache: false,
          dataType: 'json'
        }).done(function (response, textStatus, jqXHR) {
          if (textStatus === "success") {
            _this3._addRecipeToCookbooksData(recipe_id, cookbook_id).then(function (result) {
              return defer.resolve(result);
            }); // A single new event covers both prior separate events


            Drupal.analyticsEventNew( // cookbook.my_saved_recipes ? 'msr_recipe_add' : 'cbk_recipe_add',
            'add_recipe', {
              method: cookbook.my_saved_recipes ? 'my_saved_recipes' : 'cookbook',
              recipe: "".concat(recipe_name, " (").concat(recipe_id, ")"),
              content_id: recipe_id
            });
            Drupal.analyticsEvent('Add Recipe', 'Cookbook', cookbook.my_saved_recipes ? 'My Saved Recipes' : 'Cookbook', cookbook.recipes.length + 1);
            Drupal.analyticsEvent(cookbook.my_saved_recipes ? 'Add Recipe to Saved' : 'Add Recipe to Cookbook', 'Cookbook', recipe_name, cookbook.recipes.length + 1);
          } else {
            defer.reject();
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          defer.reject();
        });
        return defer;
      }
      /**
       * Remove recipe from cookbook
       *
       * @public
       * @async
       * @param {Cookbook} cookbook
       * @param {Integer} recipe_id
       * @param {String} recipe_name
       * @return {jQuery Deferred}
       */

    }, {
      key: "removeRecipe",
      value: function removeRecipe(cookbook, recipe_id, recipe_name) {
        var _this4 = this;

        var defer = $.Deferred();
        var cookbook_id = cookbook.id;
        var url = replaceTokens(endpoints.remove_recipe, {
          recipe_id: recipe_id,
          cookbook_id: cookbook_id
        });
        $.ajax({
          url: url,
          type: 'GET',
          cache: false,
          dataType: 'json'
        }).done(function (response, textStatus, jqXHR) {
          if (textStatus === "success") {
            _this4._removeRecipeFromCookbooksData(recipe_id, cookbook_id).then(function (result) {
              return defer.resolve(result);
            }); // A single new event covers both prior separate events


            Drupal.analyticsEventNew('delete_recipe', {
              method: cookbook.my_saved_recipes ? 'my_saved_recipes' : 'cookbook',
              recipe: "".concat(recipe_name, " (").concat(recipe_id, ")"),
              content_id: recipe_id
            });
            Drupal.analyticsEvent('Delete Recipe', 'Cookbook', cookbook.my_saved_recipes ? 'My Saved Recipes' : 'Cookbook', cookbook.recipes.length - 1);
            Drupal.analyticsEvent(cookbook.my_saved_recipes ? 'Delete Recipe from Saved' : 'Delete Recipe from Cookbook', 'Cookbook', recipe_name, cookbook.recipes.length - 1); // Refresh cookbook recipe list

            $("#views-exposed-form-cookbook-recipes-block-cookbook-recipes").find('input[type=submit]').trigger('click');
          } else {
            defer.reject();
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          defer.reject();
        });
        return defer;
      } //////////

    }, {
      key: "_addCookbookToCookbooksData",
      value: function _addCookbookToCookbooksData(id, title, recipes) {
        var _this5 = this;

        var defer = $.Deferred();
        this.getCookbooks().then(function () {
          _this5._cookbooks.push({
            id: id,
            title: title,
            recipes: recipes
          });

          _this5._sortCookbooksData();

          defer.resolve();
        });
        return defer;
      }
    }, {
      key: "_addRecipeToCookbooksData",
      value: function _addRecipeToCookbooksData(recipe_id, cookbook_id) {
        var _this6 = this;

        var defer = $.Deferred();
        this.getCookbooks().then(function () {
          for (var i = 0; i < _this6._cookbooks.length; i++) {
            if (_this6._cookbooks[i].id === cookbook_id) {
              if ($.inArray(recipe_id, _this6._cookbooks[i].recipes) === -1) {
                _this6._cookbooks[i].recipes.push(recipe_id);
              }

              defer.resolve({
                toggle: true // means "added"

              });
              break;
            }
          }

          defer.reject();
        });
        return defer;
      }
    }, {
      key: "_removeRecipeFromCookbooksData",
      value: function _removeRecipeFromCookbooksData(recipe_id, cookbook_id) {
        var _this7 = this;

        var defer = $.Deferred();
        this.getCookbooks().then(function () {
          for (var i = 0; i < _this7._cookbooks.length; i++) {
            if (_this7._cookbooks[i].id === cookbook_id) {
              _this7._cookbooks[i].recipes = _this7._cookbooks[i].recipes.filter(function (value) {
                return value !== recipe_id;
              });
              defer.resolve({
                toggle: false // means "removed"

              });
              break;
            }
          }

          defer.reject();
        });
        return defer;
      }
    }, {
      key: "_sortCookbooksData",
      value: function _sortCookbooksData() {
        this._cookbooks[0].my_saved_recipes = true;

        this._cookbooks.sort(function (a, b) {
          if (a.my_saved_recipes) return -1;
          if (b.my_saved_recipes) return 1;
          var a_title = a.title.toUpperCase();
          var b_title = b.title.toUpperCase();
          return a_title < b_title ? -1 : a_title > b_title ? 1 : 0;
        });
      }
    }]);

    return CookbookData;
  }(); //////////
  //
  // Globals
  //


  var _cookbookData = new CookbookData();

  var $adds = $();
  var $menu = $(); // Only one menu gets passed around, and rebuilt every time
  //////////
  //
  // Attach Drupal behavior
  //

  Drupal.behaviors.myplate_kitchen_cookbooks_new_plus_recipe = {
    attach: function attach(context, settings) {
      $(once('mpkc-plus-recipe', '.mpkc-plus-recipe', context)).each(function (i, el) {
        var $add = $(el),
            $trigger = $add.find('.mpkc-plus-recipe__trigger'),
            recipe_id = $add.data('recipe-id'),
            recipe_name = $add.data('recipe-name'); // Add to our global queue of $adds

        $adds = $adds.add($add);
        $trigger.on('click', function () {
          var is_expanded = $add.attr('aria-expanded') === 'true';
          close();

          if (!is_expanded) {
            $add.attr('aria-expanded', 'true');
            var timer = setTimeout(function () {
              return $trigger.addClass('loading');
            }, 30); // super basic debounce...
            // We need to rebuild from the data each time

            _cookbookData.getCookbooks().then(function (cookbooks) {
              $menu = buildCookbookMenu(cookbooks, recipe_id, recipe_name);
              $add.append($menu);
              addClickAwayHandler();
            }).fail(function (status) {
              showCookbookAnonymousModal();
            }).always(function () {
              $trigger.removeClass('loading');
              clearTimeout(timer);
            });
          }
        });
      });
    }
  }; //////////
  //
  // Functions that assume the existence of the global $adds and $menu
  //

  function close() {
    if ($adds.length > 0) $adds.attr('aria-expanded', 'false');
    $menu.remove();
    $menu = $();
  }

  function addClickAwayHandler() {
    // Close the menu on a click outside...
    $('body').on('click.mpkc_menu_outside', function (e) {
      var $target = $(e.target);

      if ($menu.length && !$.contains($menu[0], $target[0])) {
        close();
        $('body').off('click.mpkc_menu_outside');
      }
    });
  } //////////
  //
  // Generic helper functions
  //


  function replaceTokens(source, tokens) {
    var replaced = source;

    if (typeof tokens !== 'undefined') {
      Object.keys(tokens).forEach(function (name) {
        var value = tokens[name];
        var re = new RegExp("{".concat(name, "}"), 'g');
        replaced = replaced.replace(re, value);
      });
      replaced = replaced.replace(/\{[^\}]+\}/g, '');
    }

    return replaced;
  }

  function buildCookbookMenu(cookbooks, recipe_id, recipe_name) {
    function buildAdd() {
      // Build "Add New Cookbook" form
      var add_form_id = "mpkc-add-cookbook-form-".concat(recipe_id);
      var $trigger = $('<button class="mpkc-add-cookbook__trigger"><span>Create New Cookbook</span></button>').on('click', function () {
        $container.attr('aria-expanded', 'true');
        $input.val('').focus();
      });
      var $input = $('<input class="mpkc-add-cookbook-form__input" type="text" value="" placeholder="Cookbook Name" required>').on('keyup', function (e) {
        switch (e.which) {
          case 27:
            // ESC
            close();
            break;
        }
      });
      var $message = $('<div class="mpkc-add-cookbook-form__message">');
      var $close = $('<button type="button" class="mpkc-add-cookbook-form__close"><span>Close</span></button>').on('click', function (e) {
        e.preventDefault();
        close();
      });
      var $save = $('<button class="mpkc-add-cookbook-form__save" type="submit"><span>Save</span></button>');
      var $form = $("<form class=\"mpkc-add-cookbook-form\" id=\"".concat(add_form_id, "\">")).append($input).append($message).append($close).append($save).on('submit', function (e) {
        e.preventDefault();
        save($input.val(), recipe_id, recipe_name);
      });
      var $container = $("<div class=\"mpkc-add-cookbook\">").append($trigger).append($form);

      function close() {
        $container.attr('aria-expanded', 'false');
        $input.val('');
        $message.hide().empty();
      }

      function save(title, recipe_id, recipe_name) {
        $save.addClass('loading').prop('disabled', true);
        $message.hide().empty();

        var defer = _cookbookData.createCookbook(title, recipe_id);

        defer.then(function (result) {
          // TODO: scroll to the newly added cookbook. It may be out of view if there are many and the scroll position is just so...
          Drupal.analyticsEventNew('create_cookbook', {
            method: 'plus-button'
          }); // A single new event covers both prior separate events

          Drupal.analyticsEventNew('add_recipe', {
            method: 'cookbook',
            recipe: "".concat(recipe_name, " (").concat(recipe_id, ")"),
            content_id: recipe_id
          });
          Drupal.analyticsEvent('Create Cookbook', 'Cookbook', 'Plus Button');
          Drupal.analyticsEvent('Add Recipe', 'Cookbook', 'Cookbook', 1);
          Drupal.analyticsEvent('Add Recipe to Cookbook', 'Cookbook', recipe_name, 1);
          refresh();
          close();
        }).fail(function (message) {
          $message.html(message).show();
        }).always(function () {
          $save.removeClass('loading').prop('disabled', false);
        });
      }

      return $container;
    }

    function buildCookbooksList() {
      var $cookbooks = $();
      cookbooks.forEach(function (cookbook) {
        var has_recipe = $.inArray(recipe_id, cookbook.recipes) !== -1;
        var $cookbook = buildCookbookButton(cookbook, recipe_id);
        $cookbooks = $cookbooks.add($('<li>').append($cookbook));
      });
      return $('<ul class="mpkc-plus-recipe__cookbook-list">').append($cookbooks);
    }

    function buildCookbookButton(cookbook, recipe_id) {
      var has_recipe = $.inArray(recipe_id, cookbook.recipes) !== -1;
      var $cookbook = $("<button>".concat(cookbook.title, "</button>")).on('click', function (e) {
        $cookbook.addClass('loading');
        var defer = has_recipe ? _cookbookData.removeRecipe(cookbook, recipe_id, recipe_name) : _cookbookData.addRecipe(cookbook, recipe_id, recipe_name);
        defer.then(function (result) {
          has_recipe = result.toggle;
          toggleCookbookButton($cookbook, has_recipe);
        }).always(function () {
          $cookbook.removeClass('loading');
        });
      });
      toggleCookbookButton($cookbook, has_recipe);

      function toggleCookbookButton($btn, toggle) {
        $btn.toggleClass('active', toggle).attr('title', toggle ? 'Click to remove the recipe from this cookbook' : 'Click to add the recipe to this cookbook');
      }

      return $cookbook;
    }

    function refresh() {
      $cookbooksList.replaceWith(buildCookbooksList());
    } // Start the container.


    var $container = $('<div class="mpkc-plus-recipe__menu">'); // Get built cookbook list.

    var $cookbooksList = buildCookbooksList(); // Get built add.

    var $add = buildAdd(); // Put it all together.

    return $container.append($cookbooksList).append($add);
  }

  var cookbookAnonymousMenu = null;

  function showCookbookAnonymousModal() {
    if (!cookbookAnonymousMenu) {
      var modalTitle = Drupal.t('Create a free account to save recipes and create cookbooks'),
          createAccountBtnTxt = Drupal.t('CREATE AN ACCOUNT'),
          haveAccountTxt = Drupal.t('Already have an account?'),
          loginTxt = Drupal.t('log in');
      cookbookAnonymousMenu = $("\n       <div id=\"addCookbookAnonymousModal\" class=\"mp-modal modal\" role=\"dialog\" style=\"display: none\">\n        <div class=\"modal-dialog modal-dialog-centered tablet:width-tablet-lg\">\n         <div class=\"modal-content\">\n           <button type=\"button\" class=\"close circle-4\" data-dismiss=\"modal\"><span aria-hidden=\"true\">\xD7</span></button>\n           <div class=\"grid-row grid-gap-0\">\n              <div class=\"grid-col-5 media-col desktop:display-block display-none\"><div class=\"media-content\"></div></div>\n              <div class=\"grid-col-12 desktop:grid-col-7 txt-col\">\n                <h3>".concat(modalTitle, "</h3>\n                <a href=\"/user/login\" class=\"usa-button usa-button--md usa-button--secondary\">").concat(createAccountBtnTxt, "</a>\n                <p>").concat(haveAccountTxt, " <a href=\"/user/login\">").concat(loginTxt, "</a></p>\n              </div>\n            </div>\n          </div>\n         </div>\n        </div>\n       "));
      cookbookAnonymousMenu.appendTo($('body'));
    }

    cookbookAnonymousMenu.modal("show");
  }
})(jQuery);